/**
 * JSON-LD schema builders for page-level SEO.
 * Pair with <SEO jsonLd={...}>.
 */

import { siteConfig } from "@/config/website.config";

const ORG_REF = { "@id": `${siteConfig.url}/#organization` };
const DEFAULT_AREAS = ["Springfield", "Brisbane", "Logan", "Ipswich"];

interface ServiceSchemaInput {
  name: string;
  description: string;
  url: string;
  serviceType?: string;
  areaServed?: string[];
}

export function serviceSchema({
  name,
  description,
  url,
  serviceType,
  areaServed = DEFAULT_AREAS,
}: ServiceSchemaInput) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    description,
    serviceType: serviceType ?? name,
    url: `${siteConfig.url}${url}`,
    provider: ORG_REF,
    areaServed: areaServed.map((city) => ({ "@type": "City", name: city })),
    audience: { "@type": "Audience", audienceType: "Australian residents and businesses" },
  };
}

interface FAQ {
  question: string;
  answer: string;
}

export function faqSchema(faqs: FAQ[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };
}

interface BreadcrumbItem {
  name: string;
  url: string;
}

export function breadcrumbSchema(items: BreadcrumbItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${siteConfig.url}${it.url}`,
    })),
  };
}
